import styled from "styled-components";

export const CarouselContainer = styled.div(
  props => `
    margin-bottom: 1.5rem;
`);

export const CarouselCardContainer = styled.div(
  props => `
    width: 595px;
    height: 190px;
    padding: 24px 24px 45px 24px;
    display: flex;
    margin: auto auto;
    background: #fff url(${props.bgImage}) center center no-repeat;
    background-size: cover;
    border-radius: 10px;
    align-items:center;
    justidy-content: center;
`);

export const LeftSection = styled.div``;

export const IconWrapper = styled.img`
  height: 70px;
  width: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 16px;
  border-radius: 6px;
`;

export const RightSection = styled.div``;

export const CarouselTitle = styled.p`
  font-family: Quicksand;
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
  color: #ffffff;
  margin-bottom: 8px;
`;

export const CarouselSubTitle = styled.p`
  font-family: Quicksand;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #ffffff;
  margin-bottom: 16px;
  max-width: 405px;
`;

export const CarousellerCtaWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const CarouselCta = styled.button`
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  font-family: Quicksand;
  font-weight: 700;
  font-size: 20px;
  line-height: 25px;
  color: #ffffff;
  margin-right: 6px;
`;

export const RightArrow = styled.img`
  height: 13px;
  width: 8px;
  margin-top: 3px;
`;
